import {paDom, get} from '../paDom';
import {style} from './paTab.scss';

/**
 *
 * @type {{init: (function())}}
 *
 *
 *
 *
 <!-- Nav tabs -->
 <ul class="pa-tabs">
 <li><a class="pa-tab-link active" href="#pa-tab-1">tab 1</a></li>
 <li><a class="pa-tab-link" href="#pa-tab-2">tab 2</a></li>
 <li><a class="pa-tab-link" href="#pa-tab-3">tab 3</a></li>
 <li><a class="pa-tab-link" href="#pa-tab-4">tab 4</a></li>
 </ul>

 <!-- Tab panes -->
 <div class="pa-tab-panes">
 <div class="pa-tab-pane" id="pa-tab-1">1</div>
 <div class="pa-tab-pane" id="pa-tab-2">2</div>
 <div class="pa-tab-pane" id="pa-tab-3">3</div>
 <div class="pa-tab-pane" id="pa-tab-4">4</div>
 </div>
 *
 */

export const paTab = {
    init() {
        this.addListeners();
        this.setDefaultTabActive();
    },
    setDefaultTabActive() {
        let links = paDom.get('.pa-tabs a'),
            panes = paDom.get('.pa-tab-pane');
        if (links.length && panes.length) {
            links[0].classList.add('active');
            panes[0].classList.add('active');
        }
    },
    addListeners() {
        let links = paDom.get('.pa-tabs a');

        for (let i = 0; i < links.length; i++) {
            links[i].onclick = function (e) {
                e.preventDefault();
                let link = get(this),
                    tab = link.parent('li'),
                    href = link.getAttribute('href'),
                    tabSiblings = tab.siblings();


                for (let i = 0; i < tabSiblings.length; i++) {
                    tabSiblings[i].firstElementChild.classList.remove('active');
                }
                link.classList.add('active');

                let page = get(href),
                    siblings = page.siblings();

                for (let i = 0; i < siblings.length; i++) {
                    siblings[i].classList.remove('active');
                }

                page.classList.add('active');
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/js/framework/components/paTab.js